import { put, takeEvery } from 'redux-saga/effects';

import {
  updatePagesCalendarSelectedMonth,
  updatePagesHistoryCalendarSelectedDate,
  updatePagesCalendarSelectedYear,
  selectPagesHistoryCalendarDate,
  selectPagesHistoryCalendarMonth,
  selectPagesHistoryCalendarYear,
  startPagesCalendarSaga,
  cancelPagesCalendarSaga,
} from './actions';

import { IAction } from '../../../interfaces/IAction';
import { createCancellableSaga } from '../../../helpers';
import { getType } from 'typesafe-actions';

function* pagesCalendarSaga() {
  yield takeEvery([getType(selectPagesHistoryCalendarDate)], function*(action: IAction) {
    yield put(updatePagesHistoryCalendarSelectedDate(action.payload));
  });

  yield takeEvery([getType(selectPagesHistoryCalendarMonth)], function*(action: IAction) {
    yield put(updatePagesCalendarSelectedMonth(action.payload));
  });

  yield takeEvery([getType(selectPagesHistoryCalendarYear)], function*(action: IAction) {
    yield put(updatePagesCalendarSelectedYear(action.payload));
  });
}

export default createCancellableSaga({
  START_SAGA_ACTION: getType(startPagesCalendarSaga),
  CANCEL_SAGA_ACTION: getType(cancelPagesCalendarSaga),
  cancellableTask: pagesCalendarSaga,
});



// WEBPACK FOOTER //
// ./src/containers/PagesHistory/PagesHistoryCalendar/saga.ts